import { Box, Button, Divider, Slider, styled, Typography } from '@mui/material'
import { createFileRoute } from '@tanstack/react-router'
import AutoFixHighOutlinedIcon from '@mui/icons-material/AutoFixHighOutlined';
import TextsmsOutlinedIcon from '@mui/icons-material/TextsmsOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';
import React, { useState, useEffect } from 'react';
import { useCandidateStore } from 'store/candidateStore';
import axios from 'axios';


export const Route = createFileRoute('/(partner)/_partner/review-mode-old')({
  component: RouteComponent,
})

const RainbowSlider = styled(Slider)({
    height: '8px',
  
    '& .MuiSlider-rail': {
      height: '8px',
      backgroundColor: '#F0F1F3',
      borderRadius: '4px',
    },
  
    '& .MuiSlider-track': {
      height: '8px',
      border: 'none',
      borderRadius: '4px',
      background: 'linear-gradient(90deg, #31C07D 0%, #47C5FB 35%, #9747FF 75%, #EB4335 100%)',
    },
  
    '& .MuiSlider-thumb': {
        height: '20px',
        width: '20px',
        backgroundColor: '#EB4335',
        boxShadow: '0px 2px 4px rgba(0,0,0,0.2)',
        border: 'none',
        position: 'relative',

        '&::before': {
            content: '""',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            backgroundColor: '#fff',
        },

        '&:hover': {
            boxShadow: '0px 2px 8px rgba(235, 67, 53, 0.4)',
        },
    },
  });

function RouteComponent() {
  const [submittedCategories, setSubmittedCategories] = useState<any[]>([]);
  const [submittedQuestions, setSubmittedQuestions] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingQuestions, setIsLoadingQuestions] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submittingType, setSubmittingType] = useState<'correct' | 'incorrect' | null>(null);
  const [currentRating, setCurrentRating] = useState({
    isCorrect: null as boolean | null,
    comment: 'Odlicno!',
    score: 0
  });
  
  const { selectedCandidate, currentQuestionIndex, setCurrentQuestionIndex } = useCandidateStore();

  const handleChange = (_event: Event, newValue: number | number[]) => {
    const score = Array.isArray(newValue) ? newValue[0] : newValue;
    setCurrentRating(prev => ({ ...prev, score }));
  };

  // Navigate to specific question
  const goToQuestion = (questionIndex: number) => {
    setCurrentQuestionIndex(questionIndex);
    
    // Load existing review data if the question was already reviewed
    const question = submittedQuestions[questionIndex];
    if (question && question.reviewed) {
      setCurrentRating({
        isCorrect: question.isCorrect,
        comment: question.comment || 'Odlicno!',
        score: question.score || 0
      });
    } else {
      setCurrentRating({ isCorrect: null, comment: 'Odlicno!', score: 0 });
    }
  };

  // Navigation functions
  const goToNextQuestion = () => {
    if (currentQuestionIndex < submittedQuestions.length - 1) {
      const nextIndex = currentQuestionIndex + 1;
      setCurrentQuestionIndex(nextIndex);
      
      // Load existing review data if the next question was already reviewed
      const nextQuestion = submittedQuestions[nextIndex];
      if (nextQuestion && nextQuestion.reviewed) {
        setCurrentRating({
          isCorrect: nextQuestion.isCorrect,
          comment: nextQuestion.comment || 'Odlicno!',
          score: nextQuestion.score || 0
        });
      } else {
        setCurrentRating({ isCorrect: null, comment: 'Odlicno!', score: 0 });
      }
    }
  };

  const goToPreviousQuestion = () => {
    if (currentQuestionIndex > 0) {
      const prevIndex = currentQuestionIndex - 1;
      setCurrentQuestionIndex(prevIndex);
      
      // Load existing review data if the previous question was already reviewed
      const prevQuestion = submittedQuestions[prevIndex];
      if (prevQuestion && prevQuestion.reviewed) {
        setCurrentRating({
          isCorrect: prevQuestion.isCorrect,
          comment: prevQuestion.comment || 'Odlicno!',
          score: prevQuestion.score || 0
        });
      } else {
        setCurrentRating({ isCorrect: null, comment: 'Odlicno!', score: 0 });
      }
    }
  };

  // Submit review for current question
  const submitReview = async (isCorrect: boolean) => {
    if (!currentQuestion || !selectedCandidate?.submittedInterviewId) {
      setError('No question or candidate selected');
      return;
    }

    const submitType = isCorrect ? 'correct' : 'incorrect';
    setSubmittingType(submitType);
    setIsSubmitting(true);
    setError(null);

    try {
      const token = localStorage.getItem('token');
      const reviewData = {
        comment: currentRating.comment,
        isCorrect: isCorrect,
        score: currentRating.score
      };

      console.log('Submitting review:', reviewData);
      console.log('Question ID:', currentQuestion.id);
      console.log('Category ID:', currentQuestion.categoryId);

      const response = await axios.put(
        `https://interviewer.runasp.net/api/submittedInterviews/${selectedCandidate.submittedInterviewId}/submittedCategories/${currentQuestion.categoryId}/submittedQuestions/${currentQuestion.id}/review`,
        reviewData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      console.log('Review submitted successfully:', response.data);
      console.log('Full API Response:', {
        status: response.status,
        statusText: response.statusText,
        headers: response.headers,
        data: response.data,
        config: {
          url: response.config.url,
          method: response.config.method,
          headers: response.config.headers
        }
      });
      
      // Update the current question with the submitted review
      const updatedQuestions = [...submittedQuestions];
      const updatedQuestion = {
        ...currentQuestion,
        isCorrect: isCorrect,
        comment: currentRating.comment,
        score: currentRating.score,
        reviewed: true
      };
      
      updatedQuestions[currentQuestionIndex] = updatedQuestion;
      setSubmittedQuestions(updatedQuestions);

      // Reset the rating form
      setCurrentRating({ isCorrect: null, comment: 'Odlicno!', score: 0 });

      // Auto-advance to next question if available
      if (currentQuestionIndex < submittedQuestions.length - 1) {
        goToNextQuestion();
      }

    } catch (err: any) {
      console.error('Error submitting review:', err);
      setError(`Failed to submit review: ${err.response?.data?.message || err.message}`);
    } finally {
      setIsSubmitting(false);
      setSubmittingType(null);
    }
  };

  // Get current question data
  const currentQuestion = submittedQuestions[currentQuestionIndex];
  const isFirstQuestion = currentQuestionIndex === 0;
  const isLastQuestion = currentQuestionIndex === submittedQuestions.length - 1;

  // Fetch submitted questions for each category
  const fetchSubmittedQuestions = async (categories: any[]) => {
    if (!selectedCandidate?.submittedInterviewId || categories.length === 0) {
      return;
    }

    setIsLoadingQuestions(true);
    const allQuestions: any[] = [];

    try {
      const token = localStorage.getItem('token');
      
      for (const category of categories) {
        console.log(`Fetching questions for category: ${category.name} (${category.id})`);
        
        const response = await axios.get(
          `https://interviewer.runasp.net/api/submittedInterviews/${selectedCandidate.submittedInterviewId}/submittedCategories/${category.id}/submittedQuestions/review`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        
        console.log(`Questions for ${category.name}:`, response.data);
        
        // Add category info to each question
        const questionsWithCategory = response.data.map((question: any) => ({
          ...question,
          categoryId: category.id,
          categoryName: category.name
        }));
        
        allQuestions.push(...questionsWithCategory);
      }
      
      console.log('All submitted questions:', allQuestions);
      setSubmittedQuestions(allQuestions);
      
    } catch (err: any) {
      console.error('Error fetching submitted questions:', err);
      setError(`Failed to fetch questions: ${err.response?.data?.message || err.message}`);
    } finally {
      setIsLoadingQuestions(false);
    }
  };

  // Load review data when question index changes (e.g., from sidebar navigation)
  useEffect(() => {
    if (submittedQuestions.length > 0 && currentQuestionIndex >= 0) {
      const question = submittedQuestions[currentQuestionIndex];
      if (question && question.reviewed) {
        setCurrentRating({
          isCorrect: question.isCorrect,
          comment: question.comment || 'Odlicno!',
          score: question.score || 0
        });
      } else {
        setCurrentRating({ isCorrect: null, comment: 'Odlicno!', score: 0 });
      }
    }
  }, [currentQuestionIndex, submittedQuestions]);

  // Fetch submitted categories when component mounts
  useEffect(() => {
    const fetchSubmittedCategories = async () => {
      if (!selectedCandidate?.submittedInterviewId) {
        setError('No candidate selected');
        return;
      }

      console.log('Selected Candidate:', selectedCandidate);
      console.log('Submitted Interview ID:', selectedCandidate.submittedInterviewId);

      setIsLoading(true);
      setError(null);

      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(
          `https://interviewer.runasp.net/api/submittedInterviews/${selectedCandidate.submittedInterviewId}/submittedCategories`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        console.log('API Response:', response);
        console.log('Response Data:', response.data);
        setSubmittedCategories(response.data);
        
        // After fetching categories, fetch questions for each category
        await fetchSubmittedQuestions(response.data);
        
      } catch (err: any) {
        console.error('Error fetching submitted categories:', err);
        setError(err.response?.data?.message || 'Failed to fetch submitted categories');
      } finally {
        setIsLoading(false);
      }
    };

    fetchSubmittedCategories();
  }, [selectedCandidate?.submittedInterviewId]);

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography 
          sx={{ 
            cursor: isFirstQuestion ? 'default' : 'pointer', 
            color: isFirstQuestion ? 'var(--Interviewer-Lightest-Black)' : 'var(--Interviewer-Green)',
            opacity: isFirstQuestion ? 0.5 : 1
          }}
          onClick={goToPreviousQuestion}
        >
          {'< Back'}
        </Typography>
        <Typography fontWeight={600} sx={{color: 'var(--Interviewer-Green)'}}>
          {submittedQuestions.length > 0 
            ? `Question ${currentQuestionIndex + 1} of ${submittedQuestions.length}`
            : 'Question 1'
          }
        </Typography>
        <Typography 
          sx={{ 
            cursor: isLastQuestion ? 'default' : 'pointer', 
            color: isLastQuestion ? 'var(--Interviewer-Lightest-Black)' : 'var(--Interviewer-Green)',
            opacity: isLastQuestion ? 0.5 : 1
          }}
          onClick={goToNextQuestion}
        >
          {'Next question >'}
        </Typography>
      </Box>

      <Divider 
        orientation="horizontal" 
        sx={{borderColor: 'var(--Interviewer-Near-White)', mt: '16px'}} 
      />

      {/* Loading and Error States */}
      {isLoading && (
        <Box sx={{ mt: '32px', textAlign: 'center' }}>
          <Typography>Loading submitted categories...</Typography>
        </Box>
      )}

      {isLoadingQuestions && (
        <Box sx={{ mt: '16px', textAlign: 'center' }}>
          <Typography>Loading questions for each category...</Typography>
        </Box>
      )}

      {error && (
        <Box sx={{ mt: '32px', textAlign: 'center' }}>
          <Typography color="error">Error: {error}</Typography>
        </Box>
      )}

      {/* Show loading state when no questions available yet */}
      {!isLoading && !isLoadingQuestions && submittedQuestions.length === 0 && (
        <Box sx={{ mt: '32px', textAlign: 'center' }}>
          <Typography>No questions available for review.</Typography>
        </Box>
      )}

      {/* Only show question content when we have data */}
      {currentQuestion && (
        <Box sx={{mt: '32px'}}>
          <Typography variant='h1' sx={{ fontSize: '32px'}}>
            Question {currentQuestionIndex + 1}
          </Typography>
          <Typography sx={{fontSize: '16px', color: 'var(--Interviewer-Lighter-Black)', pt: '16px', lineHeight: '24px'}}>
            {currentQuestion.text}
          </Typography>

          {/* Candidate Answer */}
          <Box sx={{
            background: '#fff',
            border: '1px solid var(--Light-Gray)',
            borderRadius: '12px',
            boxShadow: '0px 1px 2px 0px #0205111A',
            mt: '16px'
          }}>
            <Box sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '24px',
            }}>
              <Typography variant='h2'>Candidate Answer</Typography>
              <Box sx={{display: 'flex', gap: '18px'}}>
                <Button 
                  variant="outlined"
                  sx={{
                    display: 'flex',
                    gap: '10px',
                    border: '1px solid var(--Interviewer-Near-White)'
                  }}>

                  <TextsmsOutlinedIcon fontSize='small'/>
                  Leave a comment
                </Button>
                <Button 
                  variant="text"
                  sx={{
                    display: 'flex',
                    gap: '10px',
                    alignItems: 'center',
                    background: 'var(--Light-Gray)',
                  }}
                >
                  <Box sx={{backgroundColor: 'var(--Interviewer-Green)', borderRadius: '100%', padding:'3px', width: '20px', height: '20px'}}>
                    <AutoFixHighOutlinedIcon fontSize='small' sx={{color: '#fff', maxWidth: '100%', maxHeight: '100%'}} />
                  </Box>
                  Interviewer Assistance
                </Button>
              </Box>
            </Box>

            <Divider 
              orientation="horizontal" 
              sx={{borderColor: 'var(--Interviewer-Near-White)'}} 
            />
            <Box sx={{
              padding: '24px',
            }}>
              {currentQuestion.textAnswer ? (
                <Typography sx={{fontSize: '20px', color: 'var(--Interviewer-Lighter-Black)', fontWeight: '600', lineHeight: '32px'}}>
                  {currentQuestion.textAnswer}
                </Typography>
              ) : currentQuestion.pickedAnswers && currentQuestion.pickedAnswers.length > 0 ? (
                <Box>
                  {currentQuestion.pickedAnswers.map((answer: any, index: number) => (
                    <Typography 
                      key={index}
                      sx={{
                        fontSize: '20px', 
                        color: 'var(--Interviewer-Lighter-Black)', 
                        fontWeight: '600', 
                        lineHeight: '32px',
                        mb: index < currentQuestion.pickedAnswers.length - 1 ? '16px' : 0
                      }}
                    >
                      {answer.answer}
                    </Typography>
                  ))}
                </Box>
              ) : (
                <Typography sx={{fontSize: '20px', color: 'var(--Interviewer-Lighter-Black)', fontWeight: '600', lineHeight: '32px'}}>
                  No answer provided
                </Typography>
              )}
            </Box>
          </Box>

          {/* Proposed Answer */}
          <Box sx={{
            background: 'var(--Light-Gray)',
            border: '1px solid var(--Light-Gray)',
            borderRadius: '12px',
            boxShadow: '0px 1px 2px 0px #0205111A',
            mt: '16px',
            padding: '24px',
          }}>
            <Typography variant='h2'>Proposed Answer</Typography>
            {currentQuestion.suggestedAnswers ? (
              <Box sx={{ mt: '16px' }}>
                {currentQuestion.suggestedAnswers.map((answer: any, index: number) => {
                  // For structure 1 (text questions), show all answers without true/false indicators
                  if (currentQuestion.structure === 1) {
                    return (
                      <Box 
                        key={index} 
                        sx={{ 
                          p: '12px',
                          bgcolor: 'white',
                          borderRadius: '8px',
                          border: '1px solid var(--Light-Gray)',
                          mt: index > 0 ? '12px' : 0
                        }}
                      >
                        <Typography sx={{
                          color: 'var(--Interviewer-Lighter-Black)',
                          fontSize: '16px',
                          fontWeight: '500',
                          lineHeight: '24px'
                        }}>
                          {answer.answer}
                        </Typography>
                      </Box>
                    );
                  }
                  
                  // For structure 2 (single choice) and structure 3 (multiple choice), show with true/false indicators
                  return (
                    <Box 
                      key={index} 
                      sx={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        gap: '12px', 
                        mt: index > 0 ? '12px' : 0,
                        p: '12px',
                        bgcolor: 'white',
                        borderRadius: '8px',
                        border: `2px solid ${answer.correct ? 'var(--Interviewer-Green)' : 'var(--Red-Error-Color)'}`
                      }}
                    >
                      <Box 
                        sx={{ 
                          width: '20px', 
                          height: '20px', 
                          borderRadius: '50%', 
                          bgcolor: answer.correct ? 'var(--Interviewer-Green)' : 'var(--Red-Error-Color)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        {answer.correct ? (
                          <CheckOutlinedIcon sx={{ color: 'white', fontSize: '16px' }} />
                        ) : (
                          <CloseOutlinedIcon sx={{ color: 'white', fontSize: '16px' }} />
                        )}
                      </Box>
                      <Typography sx={{
                        color: 'var(--Interviewer-Lighter-Black)',
                        fontSize: '16px',
                        fontWeight: '500',
                        lineHeight: '24px'
                      }}>
                        {answer.answer}
                      </Typography>
                    </Box>
                  );
                })}
              </Box>
            ) : (
              <Typography sx={{
                color: 'var(--Interviewer-Lighter-Black)',
                fontSize: '16px',
                fontWeight: '500',
                pt: '8px',
                lineHeight: '24px'
              }}>
                No suggested answers available
              </Typography>
            )}
          </Box>
          
          <Divider 
            orientation="horizontal" 
            sx={{borderColor: 'var(--Interviewer-Near-White)', my: '32px'}} 
          />

          {/* Slider */}
          <Box>
            <Box sx={{pb: '16px'}}>
              <Typography variant='h2'>Rate candidates answer</Typography>
            </Box>
            <Box sx={{ px: 2 }}>
              <RainbowSlider
                value={currentRating.score}
                onChange={handleChange}
                max={99}
                marks={[
                  { 
                    value: 0,
                    label: 'Bad'
                  },
                  { 
                    value: 99,
                    label: 'Excellent'
                  },
                ]}
                valueLabelDisplay="off"
              />
            </Box>
          </Box>


          {/* Buttons  */}
          <Box sx={{display: 'flex', flexDirection: {xs: 'column', md: 'row'}, gap: '20px', mt: '56px'}}>
            <Button 
              variant="text"
              disabled={isSubmitting}
              onClick={() => submitReview(true)}
              sx={{
                display: 'flex',
                gap: '10px',
                alignItems: 'center',
                width: '100%',
                background: 'linear-gradient(180deg, #86E9BA 0%, #31C07D 100%)',
                minHeight: '60px'
              }}
            >
              <Typography variant='h2' sx={{color: '#fff'}}>
                {submittingType === 'correct' ? 'Submitting...' : 'Mark as correct'}
              </Typography>
              <CheckOutlinedIcon fontSize='small' sx={{color: '#fff'}}/>
            </Button>
            <Button 
              variant="text"
              disabled={isSubmitting}
              onClick={() => submitReview(false)}
              sx={{
                display: 'flex',
                gap: '10px',
                alignItems: 'center',
                background: 'var(--Red-Error-Color)',
                width: '100%',
                minHeight: '60px'
              }}
            >
              <Typography variant='h2' sx={{color: '#fff'}}>
                {submittingType === 'incorrect' ? 'Submitting...' : 'Mark as incorrect'}
              </Typography>
              <CloseOutlinedIcon fontSize='small' sx={{color: '#fff'}} />
            </Button>
          </Box>

          <Divider sx={{ my: 3 }} textAlign="center">or</Divider>

          <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '3px'}}>
            <Typography sx={{color: 'var(--Interviewer-Lighter-Black)'}}>Skip question</Typography>
            <ArrowForwardIosOutlinedIcon fontSize='small' sx={{width: '16px', height: '12px'}}/>
          </Box>
        </Box>
      )}
    </Box>
  );
}
